<template>
  <div>
    <!-- Confirm modal -->
    <ConfirmationModal
      ref="confirmationModal"
      :title="confirmationTitle"
      :subtitle="confirmationSubtitle"
      :message="confirmationMessage"
      confirmColor="error darken-1"
    />

    <v-dialog max-width="500" v-model="dialog">
      <v-card rounded="lg">
        <v-card-title class="justify-space-between align-start">
          <div>
            <h3 class="text-h6 font-weight-medium">Staff List</h3>
            <p class="text-subtitle-2 text--secondary">
              Assign this loan to another person
            </p>
          </div>
          <v-btn @click="closeModal()" icon>
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 400px">
          <v-list height="350" style="overflow-y: auto">
            <v-list-item
              @click="onUserSelected(u)"
              v-for="u in authorizeUsers"
              :key="`out-${u.id}`"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">{{
                  u.username
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >{{ u.roleObject?.name || '-' }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>{{ u.email }} </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <span class="primary--text">{{ u.branch?.branchName }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageMixin from '@/mixins/page.mixin';
import SocketMixin from '@/modules/loanpro/mixins/socket.mixin';
import { LoanPoolService } from '@/modules/loanpro/services/loan-pool.service';
import { mapGetters, mapState } from 'vuex';
export default {
  mixins: [PageMixin, SocketMixin],
  data() {
    return {
      dialog: false,
      privilegeNames: '',
      loan: null,

      // confirmation modal options
      confirmationTitle: '',
      confirmationMessage: '',
      confirmationSubtitle: '',

      /**
       * If set to true, this indicates if socket mixin should ignore the listener
       */
      useSocketEmitOnly: true
    };
  },

  computed: {
    ...mapGetters('userModule', ['users']),
    ...mapState('authModule', ['user']),

    /**
     * Returns a list of all authorized users
     */
    authorizeUsers: function () {
      return this.users.filter((user) => {
        const permissions = user.roleObject?.permissions;
        const hasPrivilege =
          permissions?.filter(
            (p) =>
              p.app.toLowerCase() == 'loan-pro' &&
              this.privilegeNames.includes(p.name?.toLowerCase())
          ).length != 0;

        return user.id !== this.user.id && permissions && hasPrivilege;
      });
    }
  },

  emits: ['refresh'],

  methods: {
    /**
     * Closes the modal
     */
    closeModal() {
      this.dialog = false;
      this.loan = null;
    },

    /**
     * Opens the assignment modal
     *
     * @param { loan } user - the loan object
     * @param { Array<string> } privilegeNames - list of privileges to filter user who loan can be assigned to
     */
    openModal(loan, privilegeNames = ['progress loan']) {
      this.privilegeNames = privilegeNames.map((el) => el.toLowerCase());
      this.loan = loan;
      this.dialog = true;
    },

    /**
     * Gets called when a user is selected from the dialog
     *
     * @param { Object } user - the selected user object
     */
    async onUserSelected(user) {
      this.confirmationTitle = 'Confirm Assignment';
      this.confirmationMessage = `Are you sure you want to assign this loan to ${user.username}?`;

      this.$refs.confirmationModal.show(async () => {
        await this.assignLoanToUser(user);
        this.closeModal();
      });
    },

    /**
     * Assign loan checklist to user to be completed
     *
     * @param { Object } user - the selected user object
     */
    async assignLoanToUser(user) {
      try {
        const service = new LoanPoolService();
        await service.assignLoanToUser({
          loanId: this.loan.id,
          userId: user.id
        });

        this.showSnack({
          color: 'success',
          title: `Loan Assigned`,
          message: `Loan was assigned to ${user.username}.`
        });

        this.emitAssignLoanToUserEvent(this.loan, user);
          
        this.$emit('refresh');
          
        this.closeModal();
      } catch (error) {
        this.showSnack({
          color: 'error',
          title: `Error`,
          message: `An error occurred while assigning loan to ${user.username}.`
        });
      }
    }
  }
};
</script>
